/**
 * @generated SignedSource<<312e9d555e676dd9c6f8f1c066ebe036>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type EventCapacityType = "ATTENDEES" | "GROUPS";
import { FragmentRefs } from "relay-runtime";
export type EventDetailAttendeesList$data = {
  readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
  readonly capacity: number | null | undefined;
  readonly capacityType: EventCapacityType | null | undefined;
  readonly eventSeries: {
    readonly facility: {
      readonly copyOverrides: {
        readonly eventPlayer: {
          readonly singular: string;
        } | null | undefined;
      };
    };
  };
  readonly eventSignUps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly registrations: {
          readonly count: number;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesGroupListItemFragment" | "EventDetailAttendeesListItemFragment">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly hasWaitlist: boolean;
  readonly id: string;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentType": "EventDetailAttendeesList";
};
export type EventDetailAttendeesList$key = {
  readonly " $data"?: EventDetailAttendeesList$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailAttendeesList">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailAttendeesList",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "accessStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWaitlist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "eventPlayer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "singular",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "eventSignUps",
      "args": [
        {
          "kind": "Literal",
          "name": "waitlist",
          "value": false
        }
      ],
      "concreteType": "EventSignUpConnection",
      "kind": "LinkedField",
      "name": "signUps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationConnection",
                  "kind": "LinkedField",
                  "name": "registrations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "count",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailAttendeesListItemFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventDetailAttendeesGroupListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "signUps(waitlist:false)"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "89e9df760dba7c10ccb8555854d71f1b";

export default node;
